export const warrantyKey = 'GLD';
export const maintenanceKey = 'RPU';

export type Value = {
  [warrantyKey]?: boolean;
  [maintenanceKey]?: boolean;
};

type Data = Record<string, any>;

export const setAdditionalServices = (data: Data, value: Value) => {
  let newData = data;
  const prevState = newData?.additionalServices;
  const mechanicalWarranty = value?.[warrantyKey];
  const newDataMechanicalWarranty = prevState?.[warrantyKey];
  const maintenance = value?.[maintenanceKey];
  const newDataMaintenance = prevState?.[maintenanceKey];

  if (
    maintenance === true &&
    newDataMaintenance === true &&
    mechanicalWarranty === undefined &&
    newDataMechanicalWarranty === undefined
  ) {
    newData = {
      ...newData,
      additionalServices: {
        [warrantyKey]: true,
        [maintenanceKey]: true,
      },
    };
  } else if (
    newDataMaintenance === true &&
    newDataMechanicalWarranty === false &&
    maintenance === true &&
    mechanicalWarranty === false
  ) {
    newData = {
      ...newData,
      additionalServices: {
        [maintenanceKey]: false,
      },
    };
  }

  return newData;
};
